import { LOCALE_SUBDIRECTORY_MAPPING } from './constants';

export const getSubDirectoryLocale = (currentLocale: string): string => {
  const subDirectory = LOCALE_SUBDIRECTORY_MAPPING[currentLocale];
  return subDirectory || '';
};
